@if (country === FNOL_COUNTRY.JAPAN.countryCode) {
<div class="axis-grid">
  <div class="axis-col-lg-12">
    <div
      class="axis-grid _align-items-center axis-reveal"
      [class.axis-conceal]="uploadList?.children.length < 1"
    >
      <div class="axis-col">
        <h2
          class="axis-h5"
          i18n="@@uploadList"
        >アップロードされたファイル ({{uploaded.length}})</h2>
      </div>
      <div class="axis-col-auto">
        <ul class="axis-list-inline stack-xs">
          <!-- <li i18n="@@dragdrop">Drag and drop or</li> -->
          <li>
            <axis-upload
              [kind]="'secondary'"
              [imagePreview]="imagePreview"
              [isMulti]="isMulti"
              (listChange)="uploadFiles($event)"
              [restrictFiles]="restrictFiles"
              [title]="afterUploadButtonText"
              #fileUpload
            ></axis-upload>

          </li>
        </ul>
      </div>
    </div>
    @if (fileUploadFailed) {
    <axis-card-row>
      <axis-alert class="kind-danger">{{apiFailure}}</axis-alert>
    </axis-card-row>
    }
    @if (deleteFailedError) {
    <axis-card-row>
      <axis-alert class="kind-danger">{{deleteFailure}}</axis-alert>
    </axis-card-row>
    }
    @if (updateStatus) {
    <axis-card-row>
      <axis-alert
        class="kind-success"
        [dismissible]="true"
      >
        {{updateMsg}}
      </axis-alert>
    </axis-card-row>
    }
    @if (exceedSizeError) {
    <axis-card-row>
      <axis-alert class="kind-danger">
        {{exceedSizeErrorMsg}}
      </axis-alert>
    </axis-card-row>
    }
    @if (formatUnsupportedError) {
    <axis-card-row>
      <axis-alert class="kind-danger">
        {{formatUnsupportedErrorMsg}}
      </axis-alert>
    </axis-card-row>
    }
    @if (zeroByteError) {
    <axis-card-row>
      <axis-alert class="kind-danger">{{zeroByteErrorMsg}}</axis-alert>
    </axis-card-row>
    }
    @if (claimTypeChangedError) {
    <axis-card-row>
      <axis-alert class="kind-danger">{{claimTypeChangedErrorMsg}}</axis-alert>
    </axis-card-row>
    }
    @if ((!uploadList?.children.length && !fileLoading) || (!uploadList?.children.length && fileUploadFailed)) {
    <axis-upload
      [documentFlag]="true"
      [imagePreview]="imagePreview"
      [isMulti]="isMulti"
      (listChange)="uploadFiles($event)"
      [restrictFiles]="restrictFiles"
      [titleText]="uploadText"
      type="dragndrop"
      #fileUpload
    >
    </axis-upload>
    }
    <axis-card
      axis-drag-highlight
      [class._hidden]="uploadList?.children.length < 1 && !fileLoading"
      [class.no-highlight]="uploadList?.children.length < 1"
      class="size-small"
      [documentFlag]="true"
      [imagePreview]="imagePreview"
      [isMulti]="isMulti"
      (listChange)="uploadFiles($event)"
      [restrictFiles]="restrictFiles"
      type="dragndrop"
      #fileUpload="axis-drag-highlight"
    >
      <div
        class="axis-table-mobile axis-table-responsive axis-upload-wrapper axis-flush axis-reveal"
        [class.axis-conceal]="uploadList?.children.length < 1 && !fileLoading"
      >
        <table
          aria-describedby="idUploadCaption"
          aria-label="Uploaded Files"
          class="axis-table axis-table-basic"
          role="grid"
        >
          <caption id="idUploadCaption">
            Lists uploaded files.
          </caption>
          <colgroup>
            <col>
            <col>
            <col>
          </colgroup>
          <tbody
            role="rowgroup"
            #uploadList
          >
            <!-- uploaded file list -->
            @for (item of (uploaded); track trackByIndex(index); let index = $index) {
            @if (item?.active) {
            <tr
              [class.row-active]="item.highlight || item.edit"
              [class.row-success]="item.newHighlight"
              (mouseenter)="item.highlight=true"
              (mouseleave)="item.highlight=false"
              role="row"
              class="axis-grid _nm"
            >
              <td
                data-heading="File"
                i18n-data-heading="File@@uploadFileList"
                role="gridcell"
                class="axis-col-lg-5"
              >
                <axis-media class="align-middle">
                  <axis-media-left>
                    @if (item.newHighlight) {
                    <axis-icon
                      aria-hidden="true"
                      class="size-xlarge rotate-left"
                      icon="sync"
                    ></axis-icon>
                    }
                    @if (!item.newHighlight) {
                    @if (!item.img) {
                    <axis-icon
                      class="size-xlarge"
                      [icon]="item.uploadIcon"
                    ></axis-icon>
                    }
                    @if (item.img) {
                    <img
                      alt="Upload Image"
                      class="axis-img-circle img-responsive"
                      [src]="item.src"
                    >
                    }
                    }
                  </axis-media-left>
                  <axis-media-body>
                    <div
                      class="_text-bold"
                      [class.axis-conceal]="item.edit"
                    >
                      <h6
                        class="_word-break"
                        [innerHtml]="item.name"
                      ></h6>
                    </div>
                    <div
                      class="axis-form-group axis-reveal"
                      [class.axis-conceal]="!item.edit"
                      [class._hidden]="editMultipleFields"
                      [class.has-axis-error]="editedNameVar['touched'] && editedNameVar['blurred'] &&
                          editedNameVar.value===''"
                      [class.has-axis-required]="editedNameVar.value===''"
                    >
                      <input
                        aria-label="File Name"
                        [attr.aria-describedby]="editedNameVar['touched'] &&
                            editedNameVar.value==='' ? 'editedNameError-'+index : null"
                        [attr.aria-invalid]="editedNameVar['touched'] && editedNameVar.value===''"
                        autocomplete="off"
                        axis-input-clear
                        (blur)="editedNameVar['blurred']=true"
                        class="axis-form-control"
                        (cut)="item.edited=editedNameVar.value"
                        (focus)="editedNameVar['touched']=true;editedNameVar['blurred']=false"
                        id="editedName-{{index}}"
                        (keyup)="item.edited=editedNameVar.value"
                        (keyup.enter)="renameFile(item,editedNameVar)"
                        (onClear)="item.edited=''"
                        (paste)="item.edited=editedNameVar.value"
                        placeholder="Enter a file name..."
                        required
                        type="text"
                        [value]="item.name"
                        #editedNameVar
                      >
                      <div
                        [attr.aria-hidden]="!editedNameVar['touched'] || editedNameVar.value!==''"
                        class="axis-error-block"
                        id="editedNameError-{{index}}"
                        role="alert"
                        i18n="@@cancelFile"
                      >
                        Please enter a file name or cancel.
                      </div>
                    </div>
                    <small
                      [class._hidden]="editedNameVar['blurred'] && editedNameVar['touched'] &&
                          editedNameVar.value===''"
                      class="_text-muted"
                    >
                      <span class="_mr">{{item.uploadDate}} {{item.uploadDateTime}}</span>
                      {{item.size | fileSize}} bytes
                    </small>
                  </axis-media-body>
                  @if (item.newHighlight) {
                  <axis-media-right>
                    <button
                      aria-label="Cancel Upload"
                      axis-button
                      (click)="cancelUpload(index)"
                      class="kind-icon"
                    >
                      <axis-icon
                        class="size-small"
                        icon="fail"
                      ></axis-icon>
                    </button>
                  </axis-media-right>
                  }
                </axis-media>
              </td>
              @if (!item.newHighlight) {
              <td
                i18n-data-heading="File Details@@uploadFileDetails"
                data-heading="File Details"
                role="gridcell"
                class="axis-col-lg-4"
              >
                @if (country === FNOL_COUNTRY.JAPAN.countryCode) {
                <div
                  class="axis-form-group"
                  [ngClass]=" { 'has-axis-required' : !item.supportDocType,
                  'has-axis-error' : !item.supportDocType && (ddVar['touched'] || errorMessage)}"
                >
                  <label class="axis-control-label">
                    <span i18n="@@supportDoc">書類の種類</span>
                    <span class="axis-required-indicator">*</span>
                  </label>
                  <axis-dropdown
                    [wrap]="true"
                    [attr.aria-describedby]="(ddVar['touched'] || errorMessage) && !item.supportDocType ? 'ddError' : null"
                    [attr.aria-invalid]="(ddVar['touched'] || errorMessage) && !item.supportDocType"
                    [dataProvider]="supportingDocumentType"
                    id="dd"
                    i18n-placeholder="@@claimBenefitTooltip"
                    placeholder=" 書類の種類をお選びください "
                    [ngModel]="item.supportDocType"
                    (ngModelChange)="modelChanged($event, index)"
                    [required]="true"
                    #ddVar="ngModel"
                  ></axis-dropdown>
                  @if (!item.supportDocType && (ddVar['touched'] || errorMessage)) {
                  <div
                    class="axis-error-block"
                    id="ddError"
                    role="alert"
                    i18n="@@claimBenefitError"
                  >
                    書類の種類は必須です
                  </div>
                  }
                </div>
                }
              </td>
              }
              <td
                class="_text-md-right axis-col-lg-3 _pt-xxlarge"
                i18n-data-heading="Actions@@uploadActions"
                data-heading="Actions"
                role="gridcell"
              >
                @if (!item.newHighlight) {
                <div
                  class="axis-reveal"
                  [class.axis-conceal]="item.edit"
                >

                  <button
                    aria-label="Delete File"
                    axis-button
                    (click)="modalDeleteFile.open();fileToDelete=item"
                    class="kind-icon"
                  >
                    <axis-icon
                      class="size-small"
                      icon="delete"
                    ></axis-icon>
                  </button>
                </div>
                <div
                  class="axis-reveal"
                  [class.axis-conceal]="!item.edit"
                >
                  <axis-media>
                    <axis-media-left>
                      <button
                        aria-label="Rename the File"
                        axis-button
                        (click)="renameFile(item,editedNameVar)"
                        class="kind-secondary size-small"
                        i18n="@@rename"
                      >
                        Rename
                      </button>
                    </axis-media-left>
                    <axis-media-right>
                      <button
                        aria-label="Cancel Rename"
                        axis-button
                        (click)="cancelFileEdit(item,editedNameVar,index)"
                        class="kind-icon"
                      >
                        <axis-icon
                          class="size-small"
                          icon="clear"
                        ></axis-icon>
                      </button>
                    </axis-media-right>
                  </axis-media>
                </div>
                }
              </td>
            </tr>
            }
            }
          </tbody>
        </table>
      </div>
    </axis-card>
    @if (uploadList?.children.length >= 1 && fileLoading) {
    <p class="_text-small _text-gray"><span i18n="@@uploadSupport">Supported file types: JPG, JPEG, TIF, TIFF, PDF and
        HEIC.</span> <br>
      <span i18n="@@uploadSupportCont">Maximum supported file size: 25 MB</span>
    </p>
    }
    <!--
        MODALS
        -->
    <axis-modal
      heading="Edit File"
      #modalEditFile
    >
      <axis-modal-content>
        <div class="axis-grid">
          <div class="axis-col-md-6">
            <div
              class="axis-form-group"
              [class.has-axis-error]="editedNameModalVar['touched'] && editedNameModalVar['blurred'] &&
               editedNameModalVar.value===''"
              [class.has-axis-required]="editedNameModalVar.value===''"
            >
              <label
                class="axis-control-label"
                for="editedNameModal"
              >File Name</label>
              <input
                [attr.aria-describedby]="editedNameModalVar['touched'] &&
                editedNameModalVar.value==='' ? 'editedNameModalError' : null"
                [attr.aria-invalid]="editedNameModalVar['touched'] && editedNameModalVar.value===''"
                autocomplete="off"
                axis-input-clear
                (blur)="editedNameModalVar['blurred']=true"
                class="axis-form-control"
                (cut)="fileToEdit.edited=editedNameModalVar.value"
                (focus)="editedNameModalVar['touched']=true;editedNameModalVar['blurred']=false"
                id="editedNameModal"
                (keyup)="fileToEdit.edited=editedNameModalVar.value"
                (onClear)="fileToEdit.edited=''"
                (paste)="fileToEdit.edited=editedNameModalVar.value"
                placeholder="Enter a file name..."
                required
                type="text"
                [value]="fileToEdit?.name"
                #editedNameModalVar
              >
              <div
                [attr.aria-hidden]="!editedNameModalVar['touched'] || editedNameModalVar.value!==''"
                class="axis-error-block"
                id="editedNameModalError"
                role="alert"
              >
                <span i18n='@@renameError'> Please enter a file name. </span>
              </div>
            </div>
          </div>
          <div class="axis-col-md-6">
            <div
              class="axis-form-group"
              [class.has-axis-error]="editedUploadedByModalVar['touched'] && editedUploadedByModalVar['blurred'] &&
              editedUploadedByModalVar.value===''"
              [class.has-axis-required]="editedUploadedByModalVar.value===''"
            >
              <label
                class="axis-control-label"
                for="editedUploadedByModal"
              >Uploaded by</label>
              <input
                [attr.aria-describedby]="editedUploadedByModalVar['touched'] &&
                editedUploadedByModalVar.value==='' ? 'editedUploadedByModalError' : null"
                [attr.aria-invalid]="editedUploadedByModalVar['touched'] && editedUploadedByModalVar.value===''"
                autocomplete="off"
                axis-input-clear
                (blur)="editedUploadedByModalVar['blurred']=true"
                class="axis-form-control"
                (cut)="fileToEdit.editedUploadedBy=editedUploadedByModalVar.value"
                (focus)="editedUploadedByModalVar['touched']=true;editedUploadedByModalVar['blurred']=false"
                id="editedUploadedByModal"
                (keyup)="fileToEdit.editedUploadedBy=editedUploadedByModalVar.value"
                (onClear)="fileToEdit.editedUploadedBy=''"
                (paste)="fileToEdit.editedUploadedBy=editedUploadedByModalVar.value"
                placeholder="Enter a name..."
                required
                type="text"
                [value]="fileToEdit?.uploadedBy"
                #editedUploadedByModalVar
              >
              <div
                [attr.aria-hidden]="!editedUploadedByModalVar['touched'] || editedUploadedByModalVar.value!==''"
                class="axis-error-block"
                id="editedUploadedByModalError"
                role="alert"
              >
                Please enter the name of the uploader.
              </div>
            </div>
          </div>
        </div>
      </axis-modal-content>
      <axis-modal-footer>
        <div class="axis-btn-wrapper">
          <div class="axis-btn-wrapper-right">
            <button
              axis-button
              class="kind-link"
              (click)="modalEditFile.close()"
            >Cancel</button>
            <button
              axis-button
              (click)="modalEditFile.close();saveFile()"
              class="kind-primary"
              [disabled]="fileToEdit?.edited==='' || fileToEdit?.editedUploadedBy===''"
            >Save</button>
          </div>
        </div>
      </axis-modal-footer>
    </axis-modal>
    <axis-modal
      heading="Delete File"
      i18n-heading="@@deleteFile"
      #modalDeleteFile
    >
      <axis-modal-content>
        <span class="_text-bold"> {{fileToDelete?.name}}</span> <span i18n="@@deleteConfirm"> Are you sure you want to
          delete </span>
      </axis-modal-content>
      <axis-modal-footer>
        <div class="axis-btn-wrapper">
          <div class="axis-btn-wrapper-right">
            <button
              axis-button
              (click)="modalDeleteFile.close()"
              class="kind-link"
              i18n="@@close"
            >Close</button>
            <button
              axis-button
              (click)="modalDeleteFile.close();deleteFile(fileToDelete)"
              class="kind-primary"
              i18n="@@delete"
            >Delete</button>
          </div>
        </div>
      </axis-modal-footer>
    </axis-modal>
  </div>
  <!-- <div class="axis-col-lg-4">
        <axis-custom-list></axis-custom-list>
      </div> -->
</div>
}

@if (country !== FNOL_COUNTRY.JAPAN.countryCode) {
<div>
  <div
    class="axis-grid _align-items-center axis-reveal"
    [class.axis-conceal]="uploadList?.children.length < 1"
  >
    <div class="axis-col">
      <h2 class="axis-h5">Uploaded Files ({{uploaded.length}})</h2>
    </div>
    <div class="axis-col-auto">
      <ul class="axis-list-inline stack-xs">
        <li i18n="@@dragdrop">Drag and drop or</li>
        <li>
          <axis-upload
            [kind]="'secondary'"
            [imagePreview]="imagePreview"
            [isMulti]="isMulti"
            (listChange)="uploadFiles($event)"
            [restrictFiles]="restrictFiles"
            [title]="afterUploadButtonText"
            #fileUpload
          ></axis-upload>
        </li>
      </ul>
    </div>
  </div>
  @if (fileUploadFailed) {
  <axis-card-row>
    <axis-alert class="kind-danger">{{apiFailure}}</axis-alert>
  </axis-card-row>
  }
  @if (deleteFailedError) {
  <axis-card-row>
    <axis-alert class="kind-danger">{{deleteFailure}}</axis-alert>
  </axis-card-row>
  }
  @if (zeroByteError) {
  <axis-card-row>
    <axis-alert class="kind-danger">
      {{zeroByteErrorMsg}}
    </axis-alert>
  </axis-card-row>
  }
  @if (exceedSizeError) {
  <axis-card-row>
    <axis-alert class="kind-danger">
      {{exceedSizeErrorMsg}}
    </axis-alert>
  </axis-card-row>
  }
  @if (formatUnsupportedError) {
  <axis-card-row>
    <axis-alert class="kind-danger">
      {{formatUnsupportedErrorMsg}}
      See <a
        href="supported.html"
        target="_blank"
      ><span class="link">full list</span></a>.
    </axis-alert>
  </axis-card-row>
  }
  @if ((!uploadList?.children.length && !fileLoading) || (!uploadList?.children.length && fileUploadFailed)) {
  <axis-upload
    [documentFlag]="true"
    [imagePreview]="imagePreview"
    [isMulti]="isMulti"
    (listChange)="uploadFiles($event)"
    [restrictFiles]="restrictFiles"
    [titleText]="uploadText"
    type="dragndrop"
    #fileUpload
  >
  </axis-upload>
  }
  <axis-card
    axis-drag-highlight
    [class._hidden]="uploadList?.children.length < 1 && !fileLoading"
    [class.no-highlight]="uploadList?.children.length < 1"
    class="size-small"
    [documentFlag]="true"
    [imagePreview]="imagePreview"
    [isMulti]="isMulti"
    (listChange)="uploadFiles($event)"
    [restrictFiles]="restrictFiles"
    type="dragndrop"
    #fileUpload="axis-drag-highlight"
  >
    <div
      class="axis-table-mobile axis-table-responsive axis-upload-wrapper axis-flush axis-reveal"
      [class.axis-conceal]="uploadList?.children.length < 1 && !fileLoading"
    >
      <table
        aria-describedby="idUploadCaption"
        aria-label="Uploaded Files"
        class="axis-table axis-table-basic"
        role="grid"
      >
        <caption id="idUploadCaption">
          Lists uploaded files.
        </caption>
        <colgroup>
          <col>
          <col>
          <col>
        </colgroup>
        <tbody
          role="rowgroup"
          #uploadList
        >
          <!-- uploaded file list -->
          @for (item of (uploaded); track trackByIndex(index); let index = $index) {
          @if (item.active) {
          <tr
            [class.row-active]="item.highlight || item.edit"
            [class.row-success]="item.newHighlight"
            (mouseenter)="item.highlight=true"
            (mouseleave)="item.highlight=false"
            role="row"
            class="axis-grid _nm"
          >
            <td
              data-heading="File"
              role="gridcell"
              class="axis-col-lg-5"
            >
              <axis-media class="align-middle">
                <axis-media-left>
                  @if (item.newHighlight) {
                  <axis-icon
                    aria-hidden="true"
                    class="size-xlarge rotate-left"
                    icon="sync"
                  ></axis-icon>
                  }
                  @if (!item.newHighlight) {
                  @if (!item.img) {
                  <axis-icon
                    class="size-xlarge"
                    [icon]="item.uploadIcon"
                  ></axis-icon>
                  }
                  @if (item.img) {
                  <img
                    alt="Upload Image"
                    class="axis-img-circle img-responsive"
                    [src]="item.src"
                  >
                  }
                  }
                </axis-media-left>
                <axis-media-body>
                  <div
                    class="_text-bold"
                    [class.axis-conceal]="item.edit"
                  >
                    <a
                      href
                      [innerHtml]="item.name"
                    ></a>
                  </div>
                  <div
                    class="axis-form-group axis-reveal"
                    [class.axis-conceal]="!item.edit"
                    [class._hidden]="editMultipleFields"
                    [class.has-axis-error]="editedNameVar['touched'] && editedNameVar['blurred'] &&
                        editedNameVar.value===''"
                    [class.has-axis-required]="editedNameVar.value===''"
                  >
                    <input
                      aria-label="File Name"
                      [attr.aria-describedby]="editedNameVar['touched'] &&
                          editedNameVar.value==='' ? 'editedNameError-'+index : null"
                      [attr.aria-invalid]="editedNameVar['touched'] && editedNameVar.value===''"
                      autocomplete="off"
                      axis-input-clear
                      (blur)="editedNameVar['blurred']=true"
                      class="axis-form-control"
                      (cut)="item.edited=editedNameVar.value"
                      (focus)="editedNameVar['touched']=true;editedNameVar['blurred']=false"
                      id="editedName-{{index}}"
                      (keyup)="item.edited=editedNameVar.value"
                      (keyup.enter)="renameFile(item,editedNameVar)"
                      (onClear)="item.edited=''"
                      (paste)="item.edited=editedNameVar.value"
                      placeholder="Enter a file name..."
                      required
                      type="text"
                      [value]="item.name"
                      #editedNameVar
                    >
                    <div
                      [attr.aria-hidden]="!editedNameVar['touched'] || editedNameVar.value!==''"
                      class="axis-error-block"
                      id="editedNameError-{{index}}"
                      role="alert"
                    >
                      Please enter a file name or cancel.
                    </div>
                  </div>
                  <small
                    [class._hidden]="editedNameVar['blurred'] && editedNameVar['touched'] &&
                        editedNameVar.value===''"
                    class="_text-muted"
                  >
                    <span class="_mr">{{item.uploadDate}} {{item.uploadDateTime}}</span>
                    {{item.size | fileSize}} bytes
                  </small>
                </axis-media-body>
                @if (item.newHighlight) {
                <axis-media-right>
                  <button
                    aria-label="Cancel Upload"
                    axis-button
                    (click)="cancelUpload(index)"
                    class="kind-icon"
                  >
                    <axis-icon
                      class="size-small"
                      icon="fail"
                    ></axis-icon>
                  </button>
                </axis-media-right>
                }
              </axis-media>
            </td>
            @if (!item.newHighlight) {
            <td
              data-heading="File Details"
              role="gridcell"
              class="axis-col-lg-4"
            >
              @if (country !== this.isCountryAuOrNz && !this.isNam) {
              <div
                class="axis-form-group"
                [ngClass]=" { 'has-axis-required' : !item.claimBenefitType,
                'has-axis-error' : !item.claimBenefitType && (ddVar['touched'] || errorMessage)}"
              >
                <label
                  class="axis-control-label"
                  for="dd"
                  i18n="@@claimBenefit"
                >
                  {{dropDownLabel}}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                  >*</span>
                </label>
                <axis-dropdown
                  [wrap]="true"
                  [attr.aria-describedby]="(ddVar['touched'] || errorMessage) && !item.claimBenefitType ? 'ddError' : null"
                  [attr.aria-invalid]="(ddVar['touched'] || errorMessage) && !item.claimBenefitType"
                  [dataProvider]="claimBenefitTypes"
                  id="dd"
                  i18n-placeholder="@@claimBenefitTooltip"
                  placeholder="{{typePlaceholder}}"
                  [ngModel]="item.claimBenefitType"
                  (ngModelChange)="modelChanged($event, index)"
                  [required]="true"
                  #ddVar="ngModel"
                ></axis-dropdown>
                @if (!item.claimBenefitType && (ddVar['touched'] || errorMessage)) {
                <div
                  class="axis-error-block"
                  id="ddError"
                  role="alert"
                  i18n="@@claimBenefitError"
                >
                  {{messageError}}
                </div>
                }
              </div>
              }
              @if (country === this.isCountryAuOrNz) {
              <div class="axis-form-group">
                <label class="axis-control-label">
                  Coverage Type
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                  >*</span>
                </label>
                @if (URL_PARAMETERS.TYPE !== 'CAT') {
                <p class="_text-small">Business Interruption - COVID</p>
                }
                @if (URL_PARAMETERS.TYPE === 'CAT') {
                <p class="_text-small">Property CAT</p>
                }
              </div>
              }
              @if (this.isNam) {
              <div class="axis-form-group">
                <label class="axis-control-label">
                  Claim Coverage Type
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                  >*</span>
                </label>
                <p class="_text-small">{{namSelectedClaimType}}</p>
              </div>
              }
            </td>
            }
            <td
              class="_text-md-right axis-col-lg-3 _pt-xxlarge"
              data-heading="Actions"
              role="gridcell"
            >
              @if (!item.newHighlight) {
              <div
                class="axis-reveal"
                [class.axis-conceal]="item.edit"
              >
                <button
                  aria-label="Edit File Name"
                  axis-button
                  [class._hidden]="editMultipleFields"
                  (click)="editFileName(item, index)"
                  class="kind-icon"
                  id="editButton-{{index}}"
                >
                  <axis-icon icon="edit"></axis-icon>
                </button>
                <button
                  aria-label="Edit File Parameters"
                  axis-button
                  [class._hidden]="!editMultipleFields"
                  (click)="openModalEdit(modalEditFile,item)"
                  class="kind-icon"
                  id="editButtonModal-{{index}}"
                >
                  <axis-icon icon="edit"></axis-icon>
                </button>
                <button
                  aria-label="Delete File"
                  axis-button
                  (click)="modalDeleteFile.open();fileToDelete=item"
                  class="kind-icon"
                >
                  <axis-icon
                    class="size-small"
                    icon="delete"
                  ></axis-icon>
                </button>
              </div>
              <div
                class="axis-reveal"
                [class.axis-conceal]="!item.edit"
              >
                <axis-media>
                  <axis-media-left>
                    <button
                      aria-label="Rename the File"
                      axis-button
                      (click)="renameFile(item,editedNameVar)"
                      class="size-small kind-secondary"
                    >
                      Rename
                    </button>
                  </axis-media-left>
                  <axis-media-right>
                    <button
                      aria-label="Cancel Rename"
                      axis-button
                      (click)="cancelFileEdit(item,editedNameVar,index)"
                      class="kind-icon"
                    >
                      <axis-icon
                        class="size-small"
                        icon="clear"
                      ></axis-icon>
                    </button>
                  </axis-media-right>
                </axis-media>
              </div>
              }
            </td>
          </tr>
          }
          }
        </tbody>
      </table>
    </div>
  </axis-card>
  <!--
            MODALS
            -->
  <axis-modal
    heading="Edit File"
    #modalEditFile
  >
    <axis-modal-content>
      <div class="axis-grid">
        <div class="axis-col-md-6">
          <div
            class="axis-form-group"
            [class.has-axis-error]="editedNameModalVar['touched'] && editedNameModalVar['blurred'] &&
             editedNameModalVar.value===''"
            [class.has-axis-required]="editedNameModalVar.value===''"
          >
            <label
              class="axis-control-label"
              for="editedNameModal"
            >File Name</label>
            <input
              [attr.aria-describedby]="editedNameModalVar['touched'] &&
              editedNameModalVar.value==='' ? 'editedNameModalError' : null"
              [attr.aria-invalid]="editedNameModalVar['touched'] && editedNameModalVar.value===''"
              autocomplete="off"
              axis-input-clear
              (blur)="editedNameModalVar['blurred']=true"
              class="axis-form-control"
              (cut)="fileToEdit.edited=editedNameModalVar.value"
              (focus)="editedNameModalVar['touched']=true;editedNameModalVar['blurred']=false"
              id="editedNameModal"
              (keyup)="fileToEdit.edited=editedNameModalVar.value"
              (onClear)="fileToEdit.edited=''"
              (paste)="fileToEdit.edited=editedNameModalVar.value"
              placeholder="Enter a file name..."
              required
              type="text"
              [value]="fileToEdit?.name"
              #editedNameModalVar
            >
            <div
              [attr.aria-hidden]="!editedNameModalVar['touched'] || editedNameModalVar.value!==''"
              class="axis-error-block"
              id="editedNameModalError"
              role="alert"
            >
              <span i18n='@@renameError'> Please enter a file name. </span>
            </div>
          </div>
        </div>
        <div class="axis-col-md-6">
          <div
            class="axis-form-group"
            [class.has-axis-error]="editedUploadedByModalVar['touched'] && editedUploadedByModalVar['blurred'] &&
            editedUploadedByModalVar.value===''"
            [class.has-axis-required]="editedUploadedByModalVar.value===''"
          >
            <label
              class="axis-control-label"
              for="editedUploadedByModal"
            >Uploaded by</label>
            <input
              [attr.aria-describedby]="editedUploadedByModalVar['touched'] &&
              editedUploadedByModalVar.value==='' ? 'editedUploadedByModalError' : null"
              [attr.aria-invalid]="editedUploadedByModalVar['touched'] && editedUploadedByModalVar.value===''"
              autocomplete="off"
              axis-input-clear
              (blur)="editedUploadedByModalVar['blurred']=true"
              class="axis-form-control"
              (cut)="fileToEdit.editedUploadedBy=editedUploadedByModalVar.value"
              (focus)="editedUploadedByModalVar['touched']=true;editedUploadedByModalVar['blurred']=false"
              id="editedUploadedByModal"
              (keyup)="fileToEdit.editedUploadedBy=editedUploadedByModalVar.value"
              (onClear)="fileToEdit.editedUploadedBy=''"
              (paste)="fileToEdit.editedUploadedBy=editedUploadedByModalVar.value"
              placeholder="Enter a name..."
              required
              type="text"
              [value]="fileToEdit?.uploadedBy"
              #editedUploadedByModalVar
            >
            <div
              [attr.aria-hidden]="!editedUploadedByModalVar['touched'] || editedUploadedByModalVar.value!==''"
              class="axis-error-block"
              id="editedUploadedByModalError"
              role="alert"
            >
              Please enter the name of the uploader.
            </div>
          </div>
        </div>
      </div>
    </axis-modal-content>
    <axis-modal-footer>
      <div class="axis-btn-wrapper">
        <div class="axis-btn-wrapper-right">
          <button
            axis-button
            class="kind-link"
            (click)="modalEditFile.close()"
          >Cancel</button>
          <button
            axis-button
            (click)="modalEditFile.close();saveFile()"
            class="kind-primary"
            [disabled]="fileToEdit?.edited==='' || fileToEdit?.editedUploadedBy===''"
          >Save</button>
        </div>
      </div>
    </axis-modal-footer>
  </axis-modal>
  <axis-modal
    heading="Delete File"
    #modalDeleteFile
  >
    <axis-modal-content>
      Are you sure you want to delete <span class="_text-bold">{{fileToDelete?.name}}</span>?
    </axis-modal-content>
    <axis-modal-footer>
      <div class="axis-btn-wrapper">
        <div class="axis-btn-wrapper-right">
          <button
            axis-button
            (click)="modalDeleteFile.close()"
            class="kind-link"
          >Close</button>
          <button
            axis-button
            (click)="modalDeleteFile.close();deleteFile(fileToDelete)"
            class="kind-primary"
          >Delete</button>
        </div>
      </div>
    </axis-modal-footer>
  </axis-modal>
</div>
}